import React from 'react';

export const ThemeContext = React.createContext({
  headerHeight: 'var(--header-height)',
  lefSideBarWidth: 'var(--leftSideBar-width)',
  stickyOffset: 'var(--sticky-offset)'
});
